export const generateCouponScope = (serviceId: string) => ({
  namespace: 'bookings',
  group: {
    name: 'service',
    entityId: serviceId,
  },
});
